export function resolveIosVersion(userAgentRaw = '') {
  const userAgent = userAgentRaw.toLowerCase()
  const iosFullVersion = userAgent.match(/os ((\d+_?){2,3})\s/)

  return iosFullVersion ? parseInt(iosFullVersion[1], 10) : null
}

export const parseBrowserVersion = (browserVersion: string) =>
  browserVersion.split('.').map((value) => parseInt(value))
